import { useEffect, useRef, useState } from "react";

type TFunc = (args: void) => void;

export const useTimer = (callback : TFunc, delay : number | null = 1000, limit? : number) => {
  const [iter, setIter] = useState(0);
  const callbackRef = useRef<TFunc>(callback);

  const intervalRef = useRef<any>();

  useEffect(() => {
    callbackRef.current = callback;
  }, [callback]);

  useEffect(() => {
    if (!delay && delay !== 0) {
      return;
    }
    if (limit && iter >= limit) {
      return;
    }
    intervalRef.current = setTimeout(() => {
      callbackRef.current();
      setIter(iter + 1);
    }, delay);
    return () => clearTimeout(intervalRef.current);
  }, [delay, iter, limit]);

}